import messages from './thumnailmap-translations';
import { SharedService } from '../../../shared/services/sharedService';
import { ApplicationConstants } from '../../../shared/applicationConstants';


export default{
    name: 'thumbnailmap',
    i18n: {
        messages,
    },
    data: () => {
        return {
            fallbackImage: ApplicationConstants.fallbackImageUrl,
            baseImage: ApplicationConstants.baseImageUrl
        };
    },
	filters: {
        dateFormat: (value) => SharedService.dateFormat(value),
        dateDay: (value) => SharedService.dateDay(value),
        dateMonth: (value, lang) => SharedService.dateMonth(value, lang),
        dateYear: (value) => SharedService.dateYear(value),
        truncate: (value, length) => SharedService.truncateHtml(value, length),
    },
    props: {
        selectedLang: { type: String },
        maxLengthTitle: {type: Number},
        maxLengthDesc: {type: Number},
        thumbnail: {type: Object},
        isMobile: {type: Boolean},
	},
	methods: {
		newURL: function () {
			var start = this.thumbnail.urlVisor.indexOf("/visor.html");
			return this.thumbnail.urlVisor.substring(start);
        },
        isClonable: function(element){
            return (element.clonable === "clonable");
        },
        getTitle: function(){
            var lang = this.selectedLang;
            if (lang === "") lang = ApplicationConstants.defaultLanguageCode;
            return messages[lang]["title"];
        },
        clonarMapa: function(event){
            if (event) {
                event.preventDefault();
                event.stopPropagation();
            }
            this.$emit('clonarMapa', {mapa: event.mapa});
        }
	}
};



// WEBPACK FOOTER //
// ./src/shared/components/thumbnailmap/thumbnailmap.js